import React, { useEffect, useRef, useState } from 'react';
import * as Constants from '../../../constants';
import {
  IItemsRequiredModifierGroups,
  IRequiredModifiersGroupsModifiers,
} from '../../../models/item.model';
import {
  IModifiersObjects,
  INoDressingModifier,
  IBucketSelectedIngredients,
} from '../../../models/try2Combo';
import { itemBuckets } from '../../../priceCalculation/buckets';
import { ADDITIONAL_ADDED } from '../../../priceCalculation/constants';
import { modifiersAgainstAnItem } from '../../../priceCalculation/helper';
import {
  removeTemporarilyAddedPriceForItem,
  updateTry2ComboSelectedModifiers,
} from '../../../redux/slices/itemCustomizationSlice';
import { useAppDispatch } from '../../../redux/store/store';
import Dressing from './Dressing';
import SingleItemOtherDreesing from './OtherDreesing';
import { useNavigate, useLocation } from 'react-router-dom';

interface IRequiredModifiers {
  requiredModifierGroup: IItemsRequiredModifierGroups;
  handleIngredientSelection: (data: any) => void;
  showRedBorderAnimation: boolean;
  enableOtherRequiredByDefaultSelectionAndSizeClickAction: boolean;
  setEnableOtherRequiredByDefaultSelectionAndSizeClickAction: (
    state: boolean
  ) => void;
  addToOrderHandler: () => void;
  dbId: string;
  price?: string;
}

const RequiredModifiers: React.FC<IRequiredModifiers> = (props) => {
  const dispatch = useAppDispatch();
  const {
    requiredModifierGroup,
    handleIngredientSelection,
    showRedBorderAnimation,
    enableOtherRequiredByDefaultSelectionAndSizeClickAction,
    setEnableOtherRequiredByDefaultSelectionAndSizeClickAction,
    addToOrderHandler,
    dbId,
    price,
  } = props;
  const [otherDressingData, setOtherDressingData] = useState<boolean>(false);
  const [selectedOtherDressingData, setSelectedOtherDressingData] = useState<
    IModifiersObjects[]
  >([]);
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [noDressing, setNoDressing] = useState<boolean>(false);
  const refScrollLeft = useRef(null);
  let location = useLocation();

  const isOtherDressingCardVisible = () => {
    const modifiers = requiredModifierGroup?.required_modifiers_groups_modifiers;
    if (!modifiers) return false;
    const isAllInItem = modifiers.every((m) => m?.in_item);
    const isNoneInItem = modifiers.every((m) => !m?.in_item);
    return !(isAllInItem || isNoneInItem);
  };

  useEffect(() => {
    if (showRedBorderAnimation && isOtherDressingCardVisible()) {
      const container = refScrollLeft.current;
      if (container) {
        setTimeout(() => {
          container.scrollLeft = container.scrollWidth;
        }, 300);
      }
    }
  }, [showRedBorderAnimation]);
  const history = useNavigate();
  console.log(
    enableOtherRequiredByDefaultSelectionAndSizeClickAction,
    'enableOtherRequiredByDefaultSelectionAndSizeClickAction'
  );
  useEffect(() => {
    if (enableOtherRequiredByDefaultSelectionAndSizeClickAction) {
      showIngredientsModalHandler();
    }
  }, [enableOtherRequiredByDefaultSelectionAndSizeClickAction]);

  useEffect(() => {
    if (location.state?.OpenOtherModalAsItComingFromUpsell) {
      // Get the current state from the history
      const currentState: any = location.state;

      // Remove the specific entry you want to remove
      const updatedState = {
        ...currentState,
        OpenOtherModalAsItComingFromUpsell: undefined,
      };

      // Use history.replace to update the current history entry with the new state
      history(location.pathname + location.search, {
        replace: true,
        state: updatedState,
      });
      showIngredientsModalHandler();
    }
  }, [history, location.state]);

  let otherRequiredModifiers: boolean = false;

  const selectedIngredients: IRequiredModifiersGroupsModifiers[] =
    (function () {
      return itemBuckets.specificItemBucketSelectedModifiers(
        Constants.REQUIRED_MODIFIERS,
        Constants.SINGLE_ITEM_SELECTED_SECTION.toString()
      );
    })();

  const selectedAddedIngredients: IBucketSelectedIngredients[] = (function () {
    const fromItem: any = Constants.SINGLE_ITEM_SELECTED_SECTION - 1;
    let selectedItems = itemBuckets.getSingleBucketKeyValue({
      name: Constants.REQUIRED_MODIFIERS,
      fromItem,
      modifierType: ADDITIONAL_ADDED,
      key: 'modifiers',
    });
    let selectedIngredientsFromGroup = selectedItems?.filter((ingredient => ingredient?.modifier_group_id === requiredModifierGroup?.id))
  return selectedIngredientsFromGroup;
  })();

  const isLimitExceed = (extendable_limit: number) => {
    if (extendable_limit === 1) {
      return false;
    }
    const isNoDressingExist = selectedAddedIngredients.find(
      (mod: any) => mod.modifier_name === Constants.NO_DRESSING_CAPITALIZE
    );
    if (isNoDressingExist) {
      extendable_limit += 1;
    }
    if (selectedAddedIngredients.length >= extendable_limit) {
      return true;
    } else {
      return false;
    }
  };

  const handleClick = (data, in_item) => {
    handleIngredientSelection({
      ...data,
      ...{
        modifier_group_id: requiredModifierGroup?.id,
        modifier_group_max: requiredModifierGroup?.max,
        modifier_group_base: requiredModifierGroup?.base,
        brink_modifier_group_id: requiredModifierGroup?.brink_modifier_group_id,
        in_item,
        in_slide: true,
        modifier_type: Constants.REQUIRED_MODIFIERS,
      },
    });
  };

  const updateSelectedModifiers = (modifier): void => {
    updateSelectedOtherDressingData(modifier);
    handleIngredientSelection(modifier);
  };

  const updateSelectedOtherDressingData = (modifier): void => {
    const index = selectedOtherDressingData?.findIndex(
      (selectedModifier) =>
        selectedModifier.modifier_id === modifier.modifier_id
    );
    if (index !== -1) {
      selectedOtherDressingData[index] = modifier;
      setSelectedOtherDressingData([...selectedOtherDressingData]);
    } else {
      setSelectedOtherDressingData([...selectedOtherDressingData, modifier]);
    }
  };

  const showIngredientsModalHandler = (): void => {
    itemBuckets.createBucketCopy();
    setModalShow(true);
  };

  const hideCustomizationModalHandler = (): void => {
    setModalShow(false);
    setEnableOtherRequiredByDefaultSelectionAndSizeClickAction(false);
  };

  useEffect(() => {
    if (!modalShow) {
      const container = refScrollLeft.current;

      // Scroll the container all the way to the left
      if (container) {
        setTimeout(() => {
          container.scrollLeft = 0;
        }, 200);
      }
    }
  }, [modalShow]);

  const closeModal = (): void => {
    if (enableOtherRequiredByDefaultSelectionAndSizeClickAction){
      addSelectedIngredients();
    }
    else removeSelectedIngredients();
    hideCustomizationModalHandler();
  };

  const removeSelectedIngredients = () => {
    dispatch(
      removeTemporarilyAddedPriceForItem({
        price: itemBuckets.discardBucketChanges('1'),
        item: '1',
      })
    );
    dispatch(
      updateTry2ComboSelectedModifiers({
        itemModifiers: modifiersAgainstAnItem({
          itemType: Constants.SINGLE_ITEM,
          itemId: Constants.SINGLE_ITEM_SELECTED_SECTION,
        }),
        itemId: Constants.SINGLE_ITEM_SELECTED_SECTION.toString(),
      })
    );
    setSelectedOtherDressingData([]);
  };

  const noDressingHandler = (modifier: INoDressingModifier, itemNo): void => {
    const requiredModifiersBucket = itemBuckets.getSingleBucket({
      name: Constants.REQUIRED_MODIFIERS,
      fromItem: Constants.SINGLE_ITEM_SELECTED_SECTION,
    });
    if (requiredModifiersBucket?.noDressings) {
      const noDressingState = requiredModifiersBucket?.noDressings.find(
        (e) =>
          e.id ===
          requiredModifierGroup?.required_modifiers_groups_modifiers[0]?.id
      );
      setNoDressing(noDressingState?.noDressing);
    } else {
      setNoDressing(false);
    }
    dispatch(
      removeTemporarilyAddedPriceForItem({
        price: itemBuckets.resetChangesOnNoDreesing(itemNo, modifier),
        item: itemNo,
      })
    );
    dispatch(
      updateTry2ComboSelectedModifiers({
        itemModifiers: modifiersAgainstAnItem({
          itemType: Constants.SINGLE_ITEM,
          itemId: Constants.SINGLE_ITEM_SELECTED_SECTION,
        }),
        itemId: Constants.SINGLE_ITEM_SELECTED_SECTION.toString(),
      })
    );
    itemBuckets.consoleBuckets();
  };

  const sorted = (
    required_modifiers_groups_modifiers: IRequiredModifiersGroupsModifiers[]
  ) => {
    // Remove quantity keyword
    for (let i = 0; i < required_modifiers_groups_modifiers.length; i++) {
      if (required_modifiers_groups_modifiers[i].quantity) {
        delete required_modifiers_groups_modifiers[i].quantity;
      }
    }
    // Add selected quantity to modifier
    for (let i = 0; i < required_modifiers_groups_modifiers.length; i++) {
      for (let j = 0; j < selectedIngredients.length; j++) {
        if (!required_modifiers_groups_modifiers[i].quantity) {
          if (
            required_modifiers_groups_modifiers[i].id ===
            selectedIngredients[j].modifier_id
          ) {
            required_modifiers_groups_modifiers[i].quantity =
              selectedIngredients[j].quantity;
          } else {
            required_modifiers_groups_modifiers[i].quantity = 0;
          }
        }
      }
    }
    required_modifiers_groups_modifiers.sort((a, b) => {
      return b.quantity - a.quantity;
    });
  };

  const addSelectedIngredients = (hitAddToOrder:boolean = false): void => {
    if (enableOtherRequiredByDefaultSelectionAndSizeClickAction && hitAddToOrder){
      hideCustomizationModalHandler();
      addToOrderHandler();
    }else {
      sorted(requiredModifierGroup.required_modifiers_groups_modifiers);
      hideCustomizationModalHandler();
      setSelectedOtherDressingData([]);
    }
  };

  return (
    <>
      <Dressing
        requiredModifiers={
          requiredModifierGroup?.required_modifiers_groups_modifiers
        }
        requiredModifierGroup={requiredModifierGroup}
        selectedIngredients={selectedIngredients}
        extendable_limit={requiredModifierGroup?.extendable_limit}
        min={requiredModifierGroup?.min}
        isLimitExceed={isLimitExceed}
        handleClick={handleClick}
        showIngredientsModalHandler={showIngredientsModalHandler}
        noDressingHandler={noDressingHandler}
        label={requiredModifierGroup?.label}
        refScrollLeft={refScrollLeft}
        showRedBorderAnimation={showRedBorderAnimation}
        dbId={dbId}
      />
      <SingleItemOtherDreesing
        modalShow={modalShow}
        closeModal={closeModal}
        otherDressingData={otherDressingData}
        requiredModifierGroup={requiredModifierGroup}
        noDressingHandler={noDressingHandler}
        removeSelectedIngredients={removeSelectedIngredients}
        selectedIngredients={selectedIngredients}
        selectedAddedIngredients={selectedAddedIngredients}
        updateSelectedModifiers={updateSelectedModifiers}
        noDressing={noDressing}
        selectedOtherDressingData={selectedOtherDressingData}
        addSelectedIngredients={addSelectedIngredients}
        label={requiredModifierGroup?.label}
        enableOtherRequiredByDefaultSelectionAndSizeClickAction={
          enableOtherRequiredByDefaultSelectionAndSizeClickAction
        }
        price={price}
      />
    </>
  );
};

export default RequiredModifiers;
